/**
 * The raid, as the menu sees it.
 *
 * Copy and a loader, and nothing else. Every static import here lands in the chunk that draws the
 * main menu, so this file reaches only data: the gun list and the party size. The zone, the sim and
 * the UI arrive through `load`, on the press that asks for them.
 *
 * No backdrop. The menu's scenery is the range's, and it costs that mode nothing extra because it
 * is the same bay it plays in. A raid's scenery is a generated zone, which is several hundred
 * milliseconds of work nobody pressed a button for, so this mode says it has none and the menu
 * falls back to the featured one.
 */

import { WEAPON_ORDER } from '@/sim/weapons/gunRegistry';
import {
  RAID_FACT_PARTY,
  RAID_FACT_PARTY_VALUE,
  RAID_FACT_WEAPONS,
} from '@/modes/raid/text/raidCardText';
import type { GameMode, ModeCode } from '@/modes/modeContract';

export const RAID: GameMode = {
  id: 'raid',
  title: 'Raid',
  tagline: 'Type a seed, drop into a ruin nobody has walked yet',
  facts: [
    { label: RAID_FACT_WEAPONS, value: String(WEAPON_ORDER.length) },
    { label: RAID_FACT_PARTY, value: RAID_FACT_PARTY_VALUE },
  ],
  controls: ['pointerLock', 'touch'],
  party: 'coop',
  hasBackdrop: false,
  async load(): Promise<ModeCode> {
    const app = await import('@/modes/raid/raidApp');
    return { launch: app.startRaid, createBackdrop: null };
  },
};
